import 'govuk-frontend/dist/govuk/govuk-frontend.min.css'
import { Link } from '@tanstack/react-router'
import { CSSProperties, MouseEventHandler, ReactNode } from 'react'

interface GovUKLinkProps {
  /** Internal route path — renders as TanStack Router Link */
  to?: string
  /** Route params for parameterised routes e.g. { noteId: '123' } */
  params?: Record<string, string>
  /** External URL — renders as a plain anchor */
  href?: string
  children: ReactNode
  /** Removes the visited state colour change */
  noVisitedState?: boolean
  /** Muted (grey) link style */
  muted?: boolean
  /** Inverse style for dark backgrounds */
  inverse?: boolean
  className?: string
  style?: CSSProperties
  target?: string
  rel?: string
  onClick?: MouseEventHandler<HTMLAnchorElement>
}

export function GovUKLink({
  to,
  params,
  href,
  children,
  noVisitedState,
  muted,
  inverse,
  className,
  style,
  target,
  rel,
  onClick,
}: GovUKLinkProps) {
  const classes = [
    'govuk-link',
    noVisitedState && 'govuk-link--no-visited-state',
    muted && 'govuk-link--muted',
    inverse && 'govuk-link--inverse',
    className,
  ]
    .filter(Boolean)
    .join(' ')

  if (to) {
    return (
      <Link to={to} params={params} className={classes} style={style} onClick={onClick as any}>
        {children}
      </Link>
    )
  }

  return (
    <a
      href={href}
      className={classes}
      style={style}
      target={target}
      rel={rel}
      onClick={onClick}
    >
      {children}
    </a>
  )
}
